<template>
  <div class="seo-text-wrap l-container">
    <RenderHTML :seotext="seoText" class-wrapper="block-text-description" />
  </div>
</template>

<script setup lang="ts">
import { useGlobalStore } from '~/stores/global';
import RenderHTML from '~/components/ui/RenderHTML.vue';

const globalStore = useGlobalStore();
const seoText = globalStore?.seoData?.page?.text || '';
</script>
<style lang="scss" scoped>
.seo-text-wrap {
  margin: 0 auto 48px;
  @include xl-block {
    margin: 0 auto 120px;
  }
}
</style>
